import React from 'react';
import Header from './components/Header';
import MentalTracker from './components/MentalTracker';
import RecordList from './components/RecordList';
import Notification from './components/Notification';
import './styles/app.css';

const App = () => {
  return (
    <div>
      {/* ヘッダー */}
      <Header />

      {/* メンタル記録のセクション */}
      <section style={{ padding: '20px', borderBottom: '1px solid #ddd' }}>
        <MentalTracker />
      </section>

      {/* 記録一覧のセクション */}
      <section style={{ padding: '20px' }}>
        <RecordList />
      </section>

      {/* 通知機能（必要に応じて追加） */}
      <Notification />
    </div>
  );
};

export default App;
